import styled from '@emotion/styled';
import { tokens, Button, Checkbox, Text } from '@hotjar/hotsauce';

export const StyledButton = styled(Button)`
  width: 100%;
  justify-content: center;
  margin-bottom: ${tokens.spacer.x2};
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-bottom: ${({ isInvalid }) => (isInvalid ? '0' : tokens.spacer.x3)};
  text-transform: initial;
`;

export const Title = styled.h1`
  ${tokens.text('header4')};
  margin-bottom: ${tokens.spacer.x2};
  margin-top: ${tokens.spacer.x5};
`;

export const SubTitle = styled.h2`
  ${tokens.text('body2')};
  color: ${tokens.color.text_light};
  margin-bottom: ${tokens.spacer.x3};
`;

export const Caption = styled.div`
  ${tokens.text('subtitle3')};
  color: ${tokens.color.text_disabled};
  text-transform: uppercase;
  margin-bottom: ${tokens.spacer.x1};
`;

export const StyledText = styled(Text)`
  display: inline-block;
  margin-bottom: ${tokens.spacer.x2};
`;

export const SignInText = styled.div`
  margin-top: ${tokens.spacer.x6};
  ${tokens.text('caption')};
`;
